/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Elastic_Gallery_Item_05_CategoryInputs */

const en_elastic_gallery_item_05_category = /** @type {(inputs: Elastic_Gallery_Item_05_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Innovation`)
};

const ar_elastic_gallery_item_05_category = /** @type {(inputs: Elastic_Gallery_Item_05_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ابتكار`)
};

const bn_elastic_gallery_item_05_category = /** @type {(inputs: Elastic_Gallery_Item_05_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ইনোভেশন`)
};

const de_elastic_gallery_item_05_category = /** @type {(inputs: Elastic_Gallery_Item_05_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Innovation`)
};

const es_elastic_gallery_item_05_category = /** @type {(inputs: Elastic_Gallery_Item_05_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Innovación`)
};

const fr_elastic_gallery_item_05_category = /** @type {(inputs: Elastic_Gallery_Item_05_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Innovation`)
};

const pt_elastic_gallery_item_05_category = /** @type {(inputs: Elastic_Gallery_Item_05_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inovação`)
};

const zh_elastic_gallery_item_05_category = /** @type {(inputs: Elastic_Gallery_Item_05_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创新`)
};

const tr_elastic_gallery_item_05_category = /** @type {(inputs: Elastic_Gallery_Item_05_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yenilik`)
};

const ru_elastic_gallery_item_05_category = /** @type {(inputs: Elastic_Gallery_Item_05_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Инновации`)
};

const pl_elastic_gallery_item_05_category = /** @type {(inputs: Elastic_Gallery_Item_05_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Innowacja`)
};

/**
* | output |
* | --- |
* | "Innovation" |
*
* @param {Elastic_Gallery_Item_05_CategoryInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const elastic_gallery_item_05_category = /** @type {((inputs?: Elastic_Gallery_Item_05_CategoryInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Elastic_Gallery_Item_05_CategoryInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_elastic_gallery_item_05_category(inputs)
	if (locale === "bn") return bn_elastic_gallery_item_05_category(inputs)
	if (locale === "de") return de_elastic_gallery_item_05_category(inputs)
	if (locale === "es") return es_elastic_gallery_item_05_category(inputs)
	if (locale === "fr") return fr_elastic_gallery_item_05_category(inputs)
	if (locale === "pt") return pt_elastic_gallery_item_05_category(inputs)
	if (locale === "zh") return zh_elastic_gallery_item_05_category(inputs)
	if (locale === "tr") return tr_elastic_gallery_item_05_category(inputs)
	if (locale === "ru") return ru_elastic_gallery_item_05_category(inputs)
	if (locale === "pl") return pl_elastic_gallery_item_05_category(inputs)
	return en_elastic_gallery_item_05_category(inputs)
});